import { render, staticRenderFns } from "./linkRecord.vue?vue&type=template&id=cbb1fb5c&scoped=true&"
import script from "./linkRecord.vue?vue&type=script&lang=js&"
export * from "./linkRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb1fb5c",
  null
  
)

export default component.exports